import { useToggleButton, useToggleButtonState } from "@platejs/toggle/react";
import { RiArrowRightSLine } from "@remixicon/react";
import type { PlateElementProps } from "platejs/react";
import { PlateElement, useElement } from "platejs/react";
import { cn } from "@/lib/utils";

export function ToggleElement({ children, className, ...props }: PlateElementProps) {
	const element = useElement();
	const state = useToggleButtonState(element.id as string);
	const { buttonProps, open } = useToggleButton(state);

	return (
		<PlateElement {...props} className={cn("my-1", className)}>
			<div className="flex items-start">
				<button
					type="button"
					className="mr-1 mt-1 flex size-6 shrink-0 cursor-pointer items-center justify-center rounded-sm text-muted-foreground hover:bg-muted"
					{...buttonProps}
				>
					<RiArrowRightSLine
						className={cn("size-4 transition-transform duration-200", open && "rotate-90")}
					/>
				</button>
				<div className="min-w-0 flex-1">{children}</div>
			</div>
		</PlateElement>
	);
}
